import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { DefaultContext } from '@contexts/pageContext'

import type { PageContextPayload } from '@sections/Admin/packs/Projects/screens/Detail/screens/Overview'

import type { TaskListModel } from '@models/types'

import useAttachment from '@hooks/useAttachment'
import useAttachments from '@hooks/useAttachments'

import AttachmentListItem from '@components/AttachmentListItem'

interface AssetsProps {
  taskList: TaskListModel,
}

const Assets = (props: AssetsProps) => {
  const { taskList } = props

  const pageContext = useContext<DefaultContext<PageContextPayload>>(PageContext)
  const {
    callbacks: {
      deleteAttachment,
    },
  } = pageContext

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_type: 'TaskList',
      attachable_id: taskList.id,
    },
    performHttpRequests: !!taskList.id,
  })

  const {
    filteredAttachments,
    hasFilteredAttachments,
    loading,
  } = attachmentsPayload

  const attachmentPayload = useAttachment({
    attachable_type: 'TaskList',
    attachable_id: taskList.id,
  })

  const { callbacks: { uploadAttachment } } = attachmentPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Project Assets">
      <Box flexDirection="column">
        {filteredAttachments.map(attachment => (
          <AttachmentListItem attachment={attachment} callbacks={{ deleteAttachment }} key={attachment.id} />
        ))}
      </Box>

      <DashboardModule.Footer boxProps={{ borderTop: (loading || !hasFilteredAttachments) ? 'none' : '1px solid' }}>
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => uploadAttachment()}
          marginLeft="auto"
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Upload Project Asset
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default Assets
